import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";
import TokenService from "@/services/token.service";

const StorageService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Storage/Create%20Guest_2
  uploadPhoto: async function (file, compression_type, name, invite_link_uuid) {
    try {
      const path = `/api/v1/storage/photo-upload/`;
      const headers = TokenService.getHeader();
      headers["Content-Type"] = "multipart/form-data";

      if (invite_link_uuid) {
        headers["X-INVITE-LINK-UUID"] = invite_link_uuid;
        delete headers["Authorization"];
      }

      const formData = new FormData();
      formData.append("file", file);
      if (name) formData.append("name", name);
      if (compression_type) formData.append("compression_type", compression_type);

      return await RequestService.postFormData(path, formData, headers);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default StorageService;
